import Script from 'next/script';
import { ReactElement } from 'react';

export default function LayoutScripts(): ReactElement {
	return (
		<>
			<Script id="browser-warning-init">
				{`
                var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
                // true on IE11
                // false on Edge and other IEs/browsers.
                if (isIE11) {
                    window.location = '/_n/browserwarning.htmlbrowser=ie11';
                }
                `}
			</Script>
		</>
	);
}
